export default "__VITE_ASSET__hnZJdMLQ__"